import axios from "axios"

export const rpcPost = async (servidor, token, file, json) => {

    var formData = new FormData()
    var formToSend = json

    formData.append("file", null)
    formData.append("data",
        new Blob([JSON.stringify(formToSend)], {
            type: "application/json"
        }))

    return await axios.post(servidor + "/rpc", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + token
        },
        responseType: "json", // Importante para baixar binario
    }).then(response => response)
        .catch(error => error)
}